import { render, staticRenderFns } from "./TemplateImagesTableWrapper.vue?vue&type=template&id=107db163&scoped=true"
import script from "./TemplateImagesTableWrapper.vue?vue&type=script&lang=js"
export * from "./TemplateImagesTableWrapper.vue?vue&type=script&lang=js"
import style0 from "./TemplateImagesTableWrapper.vue?vue&type=style&index=0&id=107db163&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "107db163",
  null
  
)

export default component.exports